import ApplicationsBusinessInfo from '@core/classes/Applications/ApplicationsBusinessInfo';
import CustomerEmployment from '@core/classes/Customer/CustomerEmployment';
import CustomerHousing from '@core/classes/Customer/CustomerHousing';
import CustomerResidence from '../Customer/CustomerResidence';
import FIMenuCustomerIdentification from '@core/classes/FIMenuCustomerIdentification';
import { IHavePersonalInfo } from '@core/_interfaces/Customer/IHavePersonalInfo';
import moment from 'moment';
import { SupportedLanguages } from '@core/_types/sharedTypes';
import util from '@core/services/util';
import { CDKCustomerInfo } from '../DataYourWay/CDKCustomerInfo';
export class CustomerBase implements IHavePersonalInfo {
	id?: string = null;

	//#region Personal Info
	cell?: string = null;
	addresses?: CustomerResidence[] = null; // NOTE: old, new is housingInformation.currentResidence
	dateCreated?: string = null;
	dateOfBirth?: string = null;
	dob?: string = null;
	email?: string = null;
	emailAddress?: string = null;
	firstName?: string = null;
	fullName?: string = null;
	generationSuffix?: string = null;
	identifications?: FIMenuCustomerIdentification[] = [];
	isCitizen?: boolean = null;
	isEntity?: boolean = null;
	businessInfo?: ApplicationsBusinessInfo = null;
	lastName?: string = null;
	middleName?: string = null;
	phoneNumber?: string = null;
	prefix?: string = null;
	ssnHashed?: string = null;
	ssnLast4?: string = null;
	suffix?: string = null;
	taxIdHashed?: string = null;
	taxIdLast4?: string = null;
	workPhone?: string = null;
	language?: SupportedLanguages = 'English';
	housingInformation?: CustomerHousing = null;
	employmentInformation?: CustomerEmployment = null;
	//#endregion

	cdkCustomerInfo?: CDKCustomerInfo = new CDKCustomerInfo();

	constructor(init?: Partial<CustomerBase>) {
		if (init) {
			this.id = init.id;
			this.prefix = init.prefix;
			this.firstName = init.firstName;
			this.middleName = init.middleName;
			this.lastName = init.lastName;
			this.fullName = init.fullName;
			this.isCitizen = init.isCitizen;
			this.generationSuffix = init.generationSuffix;
			this.suffix = init.suffix;
			this.ssnLast4 = init.ssnLast4;
			this.ssnHashed = init.ssnHashed;
			this.taxIdLast4 = init.taxIdLast4;
			this.taxIdHashed = init.taxIdHashed;
			this.phoneNumber = init.phoneNumber; //FIXME: old, new is cell
			this.cell = init.cell;
			this.workPhone = init.workPhone;
			this.language = init.language ?? 'English';
			this.emailAddress = init.emailAddress; //FIXME: old, new is email
			this.email = init.email;
			this.isEntity = init.isEntity;
			//TODO: remove this after SECOND RELEASE
			this.addresses = init.addresses?.map(v => new CustomerResidence(v)) ?? [];
			this.identifications = init.identifications?.map(v => new FIMenuCustomerIdentification(v)) ?? [];
			this.housingInformation = init.housingInformation ? new CustomerHousing(init.housingInformation) : null;
			this.employmentInformation = init.employmentInformation ? new CustomerEmployment(init.employmentInformation) : null;

			this.dateCreated = moment(init.dateCreated ?? new Date(), ['YYYY-MM-DDTHH:mm:ss.SSSSSSS[Z]', 'MM/DD/YYYY']).format('MM/DD/YYYY');

			if (init.dob) {
				this.dob = moment(init.dob, ['YYYY-MM-DDTHH:mm:ss', 'MM/DD/YYYY']).format('MM/DD/YYYY');
			}

			if (init.dateOfBirth) {
				// FIXME: this is old, new one is dob.
				this.dateOfBirth = moment(init.dateOfBirth, ['YYYY-MM-DDTHH:mm:ss', 'MM/DD/YYYY']).format('MM/DD/YYYY');
			}

			this.cdkCustomerInfo = init.cdkCustomerInfo;

			this.updateFullName();
		}
	}

	updateFullName() {
		if (!this.isEntity && this.firstName && this.lastName) {
			const concatenatedName = this.firstName.concat(' ').concat(this.lastName);
			this.fullName = util.toProperCase(concatenatedName);
		}
	}

	addDashesToPhoneNumber() {
		const phone = this.cell ?? this.phoneNumber;
		return util.formatPhoneNumber(phone);
	}
}
